module.exports = __webpack_public_path__ + "static/media/zhangjinhua.77ec3692.png";